export const OTHER_DOMAIN = 'Other';
export const CONTRACTOR_DOMAIN = 'Construction & Remediation';

export const BUSINESS_DOMAINS = [
  'Agriculture & Landscaping',
  'Retail',
  CONTRACTOR_DOMAIN,
  'Healthcare',
  'Education',
  'Manufacturing & Industrial',
  'Municipality',
  'Property Management',
  'Resort',
  'Professional Services',
  OTHER_DOMAIN,
] as const;

export const BUSINESS_DOMAIN_MAPPING: Record<string, string> = {
  'Agriculture/landscaping': 'Agriculture & Landscaping',
  'Chains & multi-site retailers': 'Retail',
  'Construction & remediation': 'Construction & Remediation',
  'Higher education & schools': 'Education',
  'Manufacturing & industry': 'Manufacturing & Industrial',
  Municipalities: 'Municipality',
  'Property management': 'Property Management',
  Resorts: 'Resort',
  Business: 'Professional Services',
  Busienss: 'Professional Services',
};

export type BusinessDomainType = (typeof BUSINESS_DOMAINS)[number];
